import React from "react";
import { FiSearch } from "react-icons/fi";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";

const statusOptions = [
  { value: "All", label: "All" },
  { value: "Active", label: "Active" },
  { value: "Paused", label: "Paused" },
  { value: "Error", label: "Error" },
];

export const ScrapeJobsHeader = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
}) => (
  <>
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-jp-accent-ink text-sm font-bold uppercase tracking-widest">
        SCRAPE JOBS
      </h2>
      <button className="text-[11px] text-sky-600 dark:text-sky-300 hover:text-jp-accent">
        + Define Scrape Job
      </button>
    </div>

    <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
      {/* Search bar */}
      <div className="w-full md:max-w-md">
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-jp-muted">
            <FiSearch size={16} />
          </span>
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search"
            className="w-full h-9 pl-9 pr-8 rounded-lg bg-jp-card border border-jp-line text-xs text-jp-ink placeholder:text-jp-muted focus:outline-none"
          />
        </div>
      </div>

      {/* Status filter */}
      <div className="flex items-center gap-2 text-[11px] text-jp-ink">
        <span>Status</span>
        <SimpleDropdown
          value={status}
          onChange={onStatusChange}
          options={statusOptions}
          placeholder="All"
          variant="admin"
        />
      </div>
    </div>
  </>
);
